import { render, staticRenderFns } from "./Tiers.vue?vue&type=template&id=20833a54&scoped=true&"
import script from "./Tiers.vue?vue&type=script&lang=js&"
export * from "./Tiers.vue?vue&type=script&lang=js&"
import style0 from "./Tiers.vue?vue&type=style&index=0&id=20833a54&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20833a54",
  null
  
)

export default component.exports